// ═══════════════════════════════════════════════════════
//  CONSULTEC — Datos de demostración
//  src/utils/demoData.js
//  Datos reales de prueba para funcionar SIN Firebase
// ═══════════════════════════════════════════════════════

export const DEMO_USERS = {
  supervisor: {
    uid: 'demo-sup-001', email: 'ing.hernandez@consultec.mx',
    nombre: 'Ing. Hernández', rol: 'supervisor',
    empresa: 'CONSULTEC SA de CV', plan: 'demo',
    proyectos: ['proj-001', 'proj-002']
  },
  director: {
    uid: 'demo-dir-001', email: 'director@consultec.mx',
    nombre: 'Director General', rol: 'director',
    empresa: 'CONSULTEC SA de CV', plan: 'enterprise',
    proyectos: ['proj-001', 'proj-002', 'proj-003', 'proj-004']
  }
}

export const DEMO_DATA = {
  proyectos: [
    {
      id: 'proj-001', nombre: 'Torre Residencial Caribe',
      tipo: 'desarrollo_vertical', empresa: 'CONSULTEC SA de CV',
      cliente: 'Grupo Caribe', presupuesto: 4200000,
      fechaInicio: '2025-10-02', fechaEntrega: '2026-05-30',
      avanceFisico: 68, avanceFinanciero: 61,
      presupuestoEjercido: 2560000, diasTranscurridos: 142,
      diasContractuales: 200, semanaActual: 20, semanasTotales: 28,
      status: 'activo', incidenciasAbiertas: 4,
      supervisorUid: 'demo-sup-001', ubicacion: 'Cancún, Q.Roo'
    },
    {
      id: 'proj-002', nombre: 'Hotel & Resort Tulum',
      tipo: 'hotel_resort', empresa: 'CONSULTEC SA de CV',
      cliente: 'Akumal Develop.', presupuesto: 12500000,
      fechaInicio: '2026-01-15', fechaEntrega: '2026-12-31',
      avanceFisico: 35, avanceFinanciero: 33,
      presupuestoEjercido: 4100000, diasTranscurridos: 63,
      diasContractuales: 350, semanaActual: 8, semanasTotales: 42,
      status: 'activo', incidenciasAbiertas: 1,
      supervisorUid: 'demo-sup-001', ubicacion: 'Tulum, Q.Roo'
    },
    {
      id: 'proj-003', nombre: 'Hospital Regional Norte',
      tipo: 'hospital_escuela', empresa: 'InfraSalud',
      cliente: 'Secretaría Salud', presupuesto: 23600000,
      fechaInicio: '2025-07-01', fechaEntrega: '2026-05-15',
      avanceFisico: 82, avanceFinanciero: 79,
      presupuestoEjercido: 18700000, diasTranscurridos: 261,
      diasContractuales: 320, semanaActual: 38, semanasTotales: 46,
      status: 'activo', incidenciasAbiertas: 0,
      supervisorUid: 'demo-dir-001', ubicacion: 'Mérida, Yucatán'
    },
    {
      id: 'proj-004', nombre: 'Plaza Comercial Oriente',
      tipo: 'oficinas_plaza', empresa: 'Desarrollos MM',
      cliente: 'Grupo Oriente', presupuesto: 7400000,
      fechaInicio: '2026-02-01', fechaEntrega: '2027-02-28',
      avanceFisico: 15, avanceFinanciero: 12,
      presupuestoEjercido: 900000, diasTranscurridos: 46,
      diasContractuales: 390, semanaActual: 3, semanasTotales: 52,
      status: 'activo', incidenciasAbiertas: 0,
      supervisorUid: 'demo-dir-001', ubicacion: 'Cancún, Q.Roo'
    }
  ],

  fases: [
    { id: 'f1', nombre: '1 · Cimentación', cuadrilla: 'Cuadrilla A',
      responsable: 'Ing. Ruiz', status: 'completado', pct: 100,
      fechaInicio: '2025-10-02', fechaFin: '2025-11-15', orden: 1 },
    { id: 'f2', nombre: '2 · Estructura', cuadrilla: 'Cuadrilla B',
      responsable: 'Ing. Morales', status: 'completado', pct: 100,
      fechaInicio: '2025-11-16', fechaFin: '2026-01-20', orden: 2 },
    { id: 'f3', nombre: '3 · Albanilería', cuadrilla: 'Cuadrilla C',
      responsable: 'Ing. Torres', status: 'progreso', pct: 75,
      fechaInicio: '2026-01-21', fechaFin: '2026-03-28', orden: 3 },
    { id: 'f4', nombre: '4 · Instalaciones', cuadrilla: 'Subcontratistas',
      responsable: 'Ing. Vega', status: 'demora', pct: 42,
      fechaInicio: '2026-02-01', fechaFin: '2026-04-10', orden: 4 },
    { id: 'f4a', nombre: '4a · Hidrosanitario', cuadrilla: 'Subcontratista',
      responsable: 'Subcontratista', status: 'demora', pct: 55,
      fechaInicio: '2026-02-01', fechaFin: '2026-03-20', orden: 5 },
    { id: 'f5', nombre: '5 · Acabados', cuadrilla: 'Cuadrilla D',
      responsable: 'Ing. López', status: 'pendiente', pct: 5,
      fechaInicio: '2026-04-01', fechaFin: '2026-05-30', orden: 6 }
  ],

  bitacora: [
    { id: 'b1', texto: 'Supervisión general nivel 3. Cuadrilla de 12 operarios activa. Rendimiento al 95% del programa semanal. Sin observaciones de calidad pendientes.',
      zona: 'Albanilería · N3', categoria: 'Avance', autorNombre: 'Ing. Hernández',
      autorUid: 'demo-sup-001', fotos: ['foto1.jpg', 'foto2.jpg'], createdAt: new Date().toISOString() },
    { id: 'b2', texto: 'Encofrado muro eje 6-7 N3 concluido. 240 piezas tabique rojo cal. 14. Rendimiento 98% según programa.',
      zona: 'Albanilería · N3', categoria: 'Avance', autorNombre: 'Ing. Torres',
      autorUid: 'demo-other-001', fotos: ['foto3.jpg'], createdAt: new Date(Date.now() - 3600000).toISOString() },
    { id: 'b3', texto: 'Revisión instalación hidráulica sótano. Desalineación en ramal PVC 4". INC-014 generada.',
      zona: 'Sótano · Cisterna', categoria: 'Observación', autorNombre: 'Ing. Vega',
      autorUid: 'demo-other-002', fotos: [], createdAt: new Date(Date.now() - 7200000).toISOString() }
  ],

  incidencias: [
    { id: 'inc1', titulo: 'Filtración losa nivel 4', descripcion: 'Humedad en unión viga-losa. Requiere impermeabilización urgente.',
      severidad: 'alta', zona: 'Losa N4', responsable: 'Ing. Vega', status: 'abierta',
      fotos: ['inc1_1.jpg','inc1_2.jpg'], autorNombre: 'Ing. Hernández', createdAt: new Date().toISOString() },
    { id: 'inc2', titulo: 'Desviación columna C7', descripcion: 'Desviación 2.3cm eje vertical. Pendiente revisión estructural.',
      severidad: 'alta', zona: 'Eje C · N3', responsable: null, status: 'abierta',
      fotos: ['inc2_1.jpg'], autorNombre: 'Ing. Morales', createdAt: new Date(Date.now() - 86400000).toISOString() },
    { id: 'inc3', titulo: 'Retraso entrega materiales', descripcion: 'Proveedor con 3 días de retraso en tabique. Afecta programa.',
      severidad: 'media', zona: 'General', responsable: 'Ing. Torres', status: 'notificado',
      fotos: [], autorNombre: 'Ing. Torres', createdAt: new Date(Date.now() - 172800000).toISOString() },
    { id: 'inc4', titulo: 'Fisura muro eje 4 N2', descripcion: 'Fisura capilar en muro aplanado. En revisión.',
      severidad: 'media', zona: 'Nivel 2 · Eje 4', responsable: 'Ing. Ruiz', status: 'revision',
      fotos: ['inc4_1.jpg'], autorNombre: 'Ing. Ruiz', createdAt: new Date(Date.now() - 259200000).toISOString() }
  ],

  personal: [
    { id: 'p1', nombre: 'Ing. Hernández', rol: 'Supervisor general', zona: 'General', categoria: 'ing', online: true },
    { id: 'p2', nombre: 'Ing. Torres', rol: 'Jefe cuadrilla C', zona: 'Albanilería N3', categoria: 'ing', online: true },
    { id: 'p3', nombre: 'Ing. Vega', rol: 'Instalaciones', zona: 'Sótano', categoria: 'ing', online: true },
    { id: 'p4', nombre: 'Ing. Ruiz', rol: 'Jefe cuadrilla A', zona: 'Cimentación', categoria: 'ing', online: true },
    { id: 'p5', nombre: 'Ing. Morales', rol: 'Ing. estructurista', zona: 'Estructura N4', categoria: 'ing', online: false },
    { id: 'p6', nombre: 'Mtro. Alvarado', rol: 'Maestro de obras', zona: 'Nivel 3', categoria: 'op', online: true }
  ],

  estimaciones: [
    { id: 'e1', numero: 'EST-001', contratista: 'Grupo Ruiz SA', concepto: 'Cimentación 100%', monto: 680000, periodo: 'Oct–Nov', status: 'pagado' },
    { id: 'e2', numero: 'EST-002', contratista: 'Estructuras del Sur', concepto: 'Estructura 100%', monto: 1120000, periodo: 'Nov–Ene', status: 'pagado' },
    { id: 'e3', numero: 'EST-003', contratista: 'Constru-Torres', concepto: 'Albanilería 75%', monto: 560000, periodo: 'Ene–Mar', status: 'revision' },
    { id: 'e4', numero: 'EST-004', contratista: 'Instalaciones MX', concepto: 'Hidrosanitario 55%', monto: 200000, periodo: 'Feb–Mar', status: 'pendiente' }
  ],

  documentos: [
    { id: 'd1', nombre: 'Plano arquitectónico — Planta baja', tipo: 'plano', size: 4200000, version: 'rev.3', url: '#', autorNombre: 'Arq. Soto', createdAt: '2026-03-15' },
    { id: 'd2', nombre: 'Memoria de cálculo estructural', tipo: 'memoria', size: 8700000, version: 'v1.0', url: '#', autorNombre: 'Ing. Morales', createdAt: '2025-11-10' },
    { id: 'd3', nombre: 'Contrato general de construcción', tipo: 'contrato', size: 2300000, version: 'firmado', url: '#', autorNombre: 'Lic. Ramos', createdAt: '2025-10-01' },
    { id: 'd4', nombre: 'Presupuesto de obra aprobado', tipo: 'financiero', size: 1100000, version: 'v2.0', url: '#', autorNombre: 'Adm. Flores', createdAt: '2025-10-01' }
  ]
}
